<app-portal-header
  class="w-full flex justify-content-center"
></app-portal-header>

<main
  class="w-full flex flex-column flex-grow-1 px-2 mx-0 lg:mx-0 bg-white border-x-2 border-200 main"
>
  <router-outlet *ngIf="shouldRenderContent()"></router-outlet>

  <span *ngIf="!isNavigatorCompatible()">
    <p>
      Você está usando uma versão desatualizada e incompatível do google chrome.
    </p>
    <p>É necessário atualizar para continuar utilizando o sistema.</p>
  </span>

  <p-confirmDialog
    acceptAriaLabel="Sim"
    acceptLabel="Sim"
    rejectLabel="Não"
    rejectAriaLabel="Não"
  ></p-confirmDialog>

  <p-toast position="bottom-center"></p-toast>

  <p-dialog
    header="Aviso de Manutenção"
    [visible]="showManutencaoMessage"
    [modal]="true"
    [closable]="false"
  >
    <p [innerHTML]="manutencaoMessage"></p>

    <p-footer>
      <button
        pButton
        *ngIf="!isLoading && !emManutencao"
        label="Entendi"
        (click)="desativarMensagemManutencao()"
      ></button>
    </p-footer>
  </p-dialog>
</main>

<app-portal-footer
  class="w-full flex justify-content-center"
></app-portal-footer>
